module.exports = __webpack_public_path__ + "static/media/copy.6e157fc9.svg";